<template>
  <div class="mt-10">
    <div class="lg:mt-10 md:mt-9 mt-5 lg:flex md:flex gap-2">
      <div class="container">
        <div class="w-full flex gap-4">
          <div class="w-1/5">
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/banner/image-TDNeMzHvvzRkvJQfCfK0i-1733471669"
              alt="cancer"
              class="first_img object-cover"
            />
          </div>
          <div class="w-4/5">
            <h2 class="fsize32 font-bold text4F0A4B">What is Cancer ?</h2>
            <p class="fsize14">
              Cancer is a disease caused by the uncontrolled growth and division
              of abnormal cells in the body. When healthy cells in the body
              become damaged or abnormal, they can form a mass called a tumor.
              Tumors can be benign (non-cancerous) or malignant (cancerous).
              Malignant tumors can spread to other parts of the body, making
              them more difficult to treat.
            </p>
          </div>
        </div>

        <div class="w-full flex gap-6 mt-4">
          <div class="w-2/5 flex gap-4">
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/banner/image-oqTfLN8InWgSLk3wUAg_6-1733471697"
              alt="cancer"
              class="second_img object-cover"
            />
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/banner/image-ByWDLh6OqJhNTKs2NNh-X-1733481672"
              alt="cancer"
              class="third_img object-cover"
            />
          </div>
          <div class="ml-4 w-3/5">
            <h2 class="fsize20 font-bold text4F0A4B">
              What are the various form of cancer?
            </h2>
            <p class="fsize14 mt-2">
              There are more than 100 types of cancer, each with its own unique
              symptoms, treatments, and outcomes. Some of the most common forms
              of cancer include: 
            </p>
            <div class="mt-2">
              <ul class="list-disc ml-4">
                <li class="fsize14 pb-1">
                  <span class="fsize14 font-semibold">BREAST CANCER</span>
                  a type of cancer that forms in the breast tissue.
                </li>
                <li class="fsize14 pb-1">
                  <span class="fsize14 font-semibold">LUNG CANCER</span>
                  a type of cancer that forms in the lung tissue. 
                </li>
                <li class="fsize14 pb-1">
                  <span class="fsize14 font-semibold">PROSTATE CANCER</span>
                  a type of cancer that forms in the prostate gland in men.
                </li>
                <li class="fsize14 pb-1">
                  <span class="fsize14 font-semibold">COLORECTAL CANCER</span>
                  a type of cancer that forms in the colon or rectum. 
                </li>
                <li class="fsize14 pb-1">
                  <span class="fsize14 font-semibold">SKIN CANCER</span>
                  a type of cancer that forms in the skin.
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="mt-16">
          <div class="text-center w-2/3 mx-auto">
            <h2 class="text4F0A4B fsize24 sm-fsize16 mb-2">
              What to Look For:
              <span class="font-semibold"> Early Warning Signs of Cancer</span>
            </h2>
            <p class="lg:mb-4 md:mb-4 mb-2 sm-fsize14">
              Early detection of cancer can improve the chances of successful
              treatment and recovery. Some common signs and symptoms of cancer
              include:
            </p>
          </div>
          <div class="lg:mt-12 md:mt-10 mt-6 grid grid-cols-4 gap-x-6 gap-y-8">
            <div class="">
              <img
                src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/banner/image-lY1kj2FXNifxXAaWEP8wW-1733483049"
                alt="sign"
                class="sign_img object-cover"
              />
              <p class="pt-2 fsize16 font-semibold text-center">
                Unexplained weight loss
              </p>
            </div>
            <div class="">
              <img
                src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/banner/image-_8LiFm5Htn0oMrEigRrmA-1733481962"
                alt="sign"
                class="sign_img object-cover"
              />
              <p class="pt-2 fsize16 font-semibold text-center">
                Fatigue or weakness
              </p>
            </div>
            <div class="">
              <img
                src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/banner/image-ty4YP_LILRk5-n1d8iUiV-1733471845"
                alt="sign"
                class="sign_img object-cover"
              />
              <p class="pt-2 fsize16 font-semibold text-center">
                Persistent cough
              </p>
            </div>
            <div class="">
              <img
                src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/banner/image-maxNqzhdI_2OEwjpNig_E-1733471925"
                alt="sign"
                class="sign_img object-cover"
              />
              <p class="pt-2 fsize16 font-semibold text-center">
                Changes in bowel or bladder habits 
              </p>
            </div>
            <div class="">
              <img
                src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/banner/image-rIYdnToa5BfSPTmHViIWS-1733481912"
                alt="sign"
                class="sign_img object-cover"
              />
              <p class="pt-2 fsize16 font-semibold text-center">
                Sores that do not heal
              </p>
            </div>
            <div class="">
              <img
                src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/banner/image-zSh6CrCrEgmQBdwPoo7K1-1733471779"
                alt="sign"
                class="sign_img object-cover"
              />
              <p class="pt-2 fsize16 font-semibold text-center">
                Skin changes, such as a new mole or changes in an existing mole
              </p>
            </div>
            <div class="">
              <img
                src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/banner/image-eKHKMuS2-TZK66TZKAi7C-1733471755"
                alt="sign"
                class="sign_img object-cover"
              />
              <p class="pt-2 fsize16 font-semibold text-center">
                Unusual bleeding or discharge
              </p>
            </div>
            <div class="py-3">
              <p class="fsize16 leading-5 text-4f0a4b">
                **If you notice any of these symptoms, it is essential to
                consult a doctor. Your doctor may recommend tests, such as blood
                tests, imaging tests, or biopsies, to diagnose or rule out
                cancer.
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="border-left lg:w-2/12 md:w-2/12 w-full lg:mt-0 md:mt-0 mt-4">
        <SideBlogs />
      </div> -->
    </div>
  </div>
</template>

<script>
import SideBlogs from "./components/SideBlogs.vue";
import { mapState } from "vuex";
export default {
  data() {
    return {
      blogs: [],
    };
  },
  components: {
    SideBlogs,
  },
  // computed: {
  //   ...mapState("auth", { user: "user" }),
  //   ...mapState("respitecare", ["get_all_count", "allWithdrawalRequest"]),
  //   ...mapState("cms", {
  //     pageCategories: "pageCategories",
  //     filtertags: "filtertags",
  //     filters: "filters",
  //     categorywisepagesforevent: "categorywisepagesforevent",
  //     pages: "pages",
  //     categorywisepages: "categorywisepages",
  //   }),
  // },
  // methods: {
  //   readFullBlogs(item) {
  //     this.item = item;

  //     this.handleReadMore();
  //   },
  //   async init() {
  //     this.categorywisepages.forEach((element) => {
  //       if (element.route.includes("blogs")) this.categoryId = element._id;
  //     });
  //     const { data } = await this.$store.dispatch(
  //       "cms/GetPagesbyCategoryForBlog",
  //       {
  //         id: "61adf7f010718313e80bcc4b",
  //         isSelectedCancer: true,
  //       }
  //     );
  //     // console.log("selected blogs :", data);
  //     this.blogs = data.data;
  //   },
  // },

  // async mounted() {
  //   this.init();
  //   console.log("blogs", this.blogs);
  //   console.log("categorywisepages", this.categorywisepages);
  //   console.log("pageCategories", this.pageCategories);
  // },
};
</script>

<style>
.first_img {
  height: 180px;
  width: 180px;
  border-radius: 80px 0 0 0;
}

.second_img {
  height: 180px;
  width: 180px;
  border-radius: 0 80px 0 80px;
}

.third_img {
  height: 180px;
  width: 180px;
  border-radius: 80px 0 80px 0;
}

.sign_img {
  width: 220px;
  height: 220px;
  border-radius: 50% 50% 0 0;
}
</style>
